/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import styled, { css } from 'styled-components'
import { useDisplayTheme } from 'hooks/useUiState'
import { ExplanationData } from '../../../types'
import { Explanation, ExplanationAnchor } from './Explanation'

const Container = styled.div<{ isDisabled: boolean; IconAnchor?: any }>`
  position: relative;
  box-sizing: border-box;
  width: 250px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  opacity: ${({ isDisabled }) => (isDisabled !== true ? 1 : 0.4)};

  &:hover ${ExplanationAnchor} {
    display: ${({ isDisabled }) => (isDisabled ? 'none' : 'block')};
  }
`

const TopLeftPosition = css`
  position: absolute;
  top: 8px;
  left: 8px;
`

export interface MetricItemContainerProps {
  disabledInfo: {
    isDisabled: boolean
    reason?: React.ReactNode
  }
  explanation: ExplanationData
  children: React.ReactNode
}

export const MetricItemContainer = ({
  disabledInfo,
  explanation,
  children
}: MetricItemContainerProps) => {
  const theme = useDisplayTheme()
  const { isDisabled, reason: disabledReason } = disabledInfo
  return (
    <Tooltip mode={theme} enabled={isDisabled} content={disabledReason}>
      <Container isDisabled={isDisabled}>
        <Explanation styles={TopLeftPosition} iconSize={16} {...explanation} />
        {children}
      </Container>
    </Tooltip>
  )
}
